import ContentLoader from 'react-content-loader';
import styled from 'styled-components';
export const LoaderContainer = styled.div `
  width: 100%;

  height: 46.52rem;

  ${({ theme }) => theme.media.tabletL `
    height: 28.06rem;
`};
`;
export const BoxContainer = styled.div `
  display: flex;
  flex-direction: column;

  height: 38.72rem;

  ${({ theme }) => theme.media.tabletL `
    flex-direction: row;

    height: 19.96rem;
  `};
`;
export const Box = styled.div `
  height: 18.76rem;
  width: 100%;

  padding: 2.2rem 1.2rem;

  border-radius: ${({ theme }) => theme.borderRadius.mediumHigh};
  border: 1px solid ${({ theme }) => theme.colors.surface.disabled};

  background-color: ${({ theme }) => theme.colors.surface.interactiveDefault};

  &:first-child {
    margin-bottom: 1.2rem;

    ${({ theme }) => theme.media.tabletL `
      margin-right: 1.2rem;
      margin-bottom: 0;
    `};
  }

  ${({ theme }) => theme.media.tabletL `
      padding: 2.4rem 1.2rem 2.1rem;
      height: 100%;
    `};
`;
export const AmountLoader = styled(ContentLoader) `
  width: 100%;

  height: 5.2rem;

  margin-bottom: 1.9rem;

  ${({ theme }) => theme.media.tabletL `
      margin-bottom: 2.9rem;
    `};
`;
export const Icon = styled.circle `
  cx: 3.1rem;
  cy: 50%;

  r: 1.9rem;
`;
export const Title = styled.rect `
  y: 0;
  x: 6rem;

  width: 10rem;
  height: 2rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};
`;
export const Desc = styled.rect `
  y: 2.2rem;
  x: 6rem;

  width: 15rem;
  height: 3rem;

  rx: ${({ theme }) => theme.borderRadius.mediumHigh};
`;
export const DetailsLoader = styled(ContentLoader) `
  width: 100%;
  height: 7.1rem;

  padding: 1.2rem 1.4rem 1.7rem;

  border-radius: ${({ theme }) => theme.borderRadius.mediumHigh};

  box-shadow: ${({ theme }) => theme.shadows.sm};
  background-color: ${({ theme }) => theme.colors.surface.default};
`;
export const FirstTitle = styled.rect `
  x: 0;
  y: 0;

  width: 33%;
  height: 1.8rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};
`;
export const FirstDesc = styled.rect `
  x: 0;
  y: 2rem;

  width: 30%;
  height: 2.4rem;

  rx: ${({ theme }) => theme.borderRadius.mediumHigh};
  ry: ${({ theme }) => theme.borderRadius.mediumHigh};
`;
export const Line = styled.rect `
  x: calc(50% - 0.1rem);
  y: 0rem;

  width: 0.2rem;
  height: 100%;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};
`;
export const SecondTitle = styled.rect `
  x: calc(50% + 1.4rem);
  y: 0;

  width: 33%;
  height: 1.8rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};
`;
export const SecondDesc = styled.rect `
  x: calc(50% + 1.4rem);
  y: 2rem;

  width: 30%;
  height: 2.4rem;

  rx: ${({ theme }) => theme.borderRadius.mediumHigh};
  ry: ${({ theme }) => theme.borderRadius.mediumHigh};
`;
export const ButtonWrapper = styled(ContentLoader) `
  width: 100%;
  height: 6rem;

  margin-top: 1.8rem;

  ${({ theme }) => theme.media.tabletL `
    margin-top: 2.1rem;
  `};
`;
export const ButtonLoader = styled.rect `
  x: 0;
  y: 0;

  width: 100%;
  height: 6rem;

  rx: ${({ theme }) => theme.borderRadius.mediumHigh};
  ry: ${({ theme }) => theme.borderRadius.mediumHigh};
`;
//# sourceMappingURL=styles.js.map